export enum PAYMENT_METHODS {
  KNET = 'knet',
  CREDIT_CARD = 'credit_card',
  CASH = 'CASH',
  CARD_ON_DELIVERY = 'CARDONDELIVERY',
  BENEFIT = 'benefit',
  MEEZA = 'meeza',
  MADA = 'mada',
  APPLE_PAY = 'apple_pay',
  ONLINE = 'online',
  OFFLINE = 'offline',
  WALLET = 'WALLET',
  WALLET_AND_CREDIT_CARD = 'WALLET_AND_CREDIT_CARD',
  WALLET_AND_CASH = 'WALLET_AND_CASH',
}

export const OFFLINE_PAYMENT_METHODS = [
  PAYMENT_METHODS.CASH,
  PAYMENT_METHODS.CARD_ON_DELIVERY,
  PAYMENT_METHODS.WALLET_AND_CASH,
];

export const PAYMENT_METHODS_BY_PRIORITY: string[] = [
  PAYMENT_METHODS.KNET,
  PAYMENT_METHODS.MADA,
  PAYMENT_METHODS.APPLE_PAY,
  PAYMENT_METHODS.CREDIT_CARD,
  PAYMENT_METHODS.CARD_ON_DELIVERY,
  PAYMENT_METHODS.CASH,
  PAYMENT_METHODS.MEEZA,
  PAYMENT_METHODS.BENEFIT,
];

export enum CASHBACK_APPLIES_TO {
  ONLINE_ONLY = 'online_only',
  ONLINE_AND_CASH = 'online_and_cash',
}
